import type { RootState } from '@core/core/store'

export const selectOverallSearchState = (state: RootState) => state.overallSearch.status
export const selectSearchQuery = (state: RootState) => state.overallSearch.query

export const selectSearchResults = (state: RootState) => state.overallSearch.result

/**
 * Справочники
 */
export const selectKsuCompanies = (state: RootState) => state.overallSearch.ksuCompanies

/**
 * Количество найденных во всех категориях результатов.
 */
export const selectSearchTotalResults = (state: RootState) =>
  selectSearchResults(state).reduce((acc, { count }) => acc + (count ?? 1), 0)

/**
 * Идентификатор выделенной категории
 */
export const selectSearchActiveCategoryId = (state: RootState) =>
  state.overallSearch.activeCategoryId

/**
 * Выделенная категория
 */
export const selectSearchActiveCategory = (state: RootState) => {
  const id = state.overallSearch.activeCategoryId
  return id ? state.overallSearch.result.find(result => result.id === id) : undefined
}

/**
 *  Разбиение на результата по выделенной категории.
 */
export const selectCategoryPagination = (state: RootState) => state.overallSearch.categoryPagination

/**
 *  Текущая страница результата по выделенной категории.
 */
export const selectCategoryPage = (state: RootState) => state.overallSearch.categoryPagination?.page

/**
 * Результат по выделенной категории (текущая страница).
 */
export const selectSearchInCategoryResult = (state: RootState) => state.overallSearch.categoryResult
